import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CheckCircle from '@mui/icons-material/CheckCircle';
import { useTheme } from '@mui/material/styles';
import { Grid, Stack } from '@mui/material';

type Props = {
    step: number
    steps: string[]
}

const AIWizardSteps = ({ step, steps }: Props) => {
    const theme = useTheme();

    return (
        <Grid item xs={4} md={3.5} sx={{ height: '100%', maxHeight: '100%' }}>
            <Stack
                direction="column"
                sx={{ bgcolor: 'background.paper' }}
                aria-label="contacts"
            >
                {steps.map((stepText, index) => {
                    const color = index < step ? theme.palette.success.main : index == step ? theme.palette.primary.main : theme.palette.secondary.main;

                    return <ListItem disablePadding key={stepText}>
                        <ListItemButton>
                            <ListItemIcon>
                                <CheckCircle sx={{ color: color }} />
                            </ListItemIcon>
                            <ListItemText inset primary={stepText} />
                        </ListItemButton>
                    </ListItem>
                })}
            </Stack>
        </Grid>
    );
}

export default AIWizardSteps;
